$(document).ready(function () {

$('.qty-corp-plus').on('click', function () {
  const $wrapper = $(this).closest('.qty-product-wrapper');
  const $input = $wrapper.find('.qty-corp-display');
  const minQty = parseInt($wrapper.data('min')) || 20;
  const maxQty = 999;
  let current = parseInt($input.val()) || minQty;

  if (current < maxQty) $input.val(current + 1);
});



$('.qty-corp-minus').on('click', function () {
  const $wrapper = $(this).closest('.qty-product-wrapper');
  const $input = $wrapper.find('.qty-corp-display');
  const minQty = parseInt($wrapper.data('min')) || 20;
  let current = parseInt($input.val()) || minQty;

  if (current > minQty) $input.val(current - 1);
});
$('.qty-corp-display').on('input', function () {
  let value = $(this).val(); 

});
$('.qty-corp-display').on('blur', function () {
  const $wrapper = $(this).closest('.qty-product-wrapper');
  const minQty = parseInt($wrapper.data('min')) || 20;
  const maxQty = 999;
  let value = parseInt($(this).val()) || minQty;

  if (value < minQty) value = minQty;
  if (value > maxQty) value = maxQty;

  $(this).val(value);
});
 

$('.jetzt-personalisieren, .btn-custom-corporate').on('click', function (e) {
  e.preventDefault();

  const productUrl = $(this).attr('href');
  const productId = $(this).data('product-id');
  const qty = parseInt($('#qty-corp-' + productId).val()) || 1;

  const separator = productUrl.includes('?') ? '&' : '?';
  const newUrl = productUrl + separator + 'qty=' + qty;

  window.location.href = newUrl;
});


  // =============================
  // 1. Initialize Quantity
  // =============================
  const urlParams = new URLSearchParams(window.location.search);
  const qtyFromUrl = parseInt(urlParams.get('qty'));
  const $qtyInput = $('#pralineTotalQty');

  // Use qty from URL if available, otherwise default to 1
  const initialQty = (qtyFromUrl && qtyFromUrl > 0) ? qtyFromUrl : 1;
  $qtyInput.val(initialQty);


  
  // =============================
  // 2. Choco Box Settings
  // =============================
  const minItems = window.chocoBoxMinItems || 1;
  const maxItems = window.chocoBoxMaxItems || 24;
  const redirectLink = window.chocoBoxRedirectUrl || '/';
  let selected = {}; // Object to store selected items

  // =============================
  // 3. Update Summary UI Function
  // =============================
  function updateSummaryUI() {
    const $list = $('#selectedPralines');
    $list.empty();
    let total = 0;
    let totalQty = 0;

    Object.entries(selected).forEach(([id, item]) => {
      total += item.qty * item.price;
      totalQty += item.qty;

      $list.append(`
        <li class="selected-item" data-id="${id}">
          <div class="bg-selected-item"><img src="${item.image}" alt="${item.title}" /></div>
          <span class="title-custom-qty">${item.title}</span>
          <div class="qty-controls">
            <button class="qty-minus"> </button>
            <span class="qty-display">${item.qty}</span>
            <button class="qty-plus"> </button>
          </div>
        </li>
      `);
    });

    // Always use qty from input or initialQty
    const inputQty = parseInt($qtyInput.val()) || initialQty;
    const displayQty = Math.max(totalQty, inputQty);
    $qtyInput.val(displayQty);

    const basePriceCents = Object.values(selected)[0]?.price || parseFloat($('#pralineForm input[name="id"]').data('price') || 0);
    const basePrice = basePriceCents / 100; // Convert cents to CHF
    const displayPrice = displayQty * basePrice;
    $('.gesamtsumme_text strong').text(
      'CHF ' + displayPrice.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  // =============================
  // 4. Quantity +/- Buttons
  // =============================
  $('.praline-qty-wrapper').on('click', '.plus', function () {
    let current = parseInt($qtyInput.val()) || initialQty;
  
      $qtyInput.val(current + 1);
      updateSummaryUI();
 
  });

$('.praline-qty-wrapper').on('click', '.minus', function () {
    let current = parseInt($qtyInput.val()) || initialQty;
    const minQty = initialQty; 
    console.log(minQty);
    if (current > minQty) {
        $qtyInput.val(current - 1);
        updateSummaryUI();
    }
});


$('#pralineTotalQty').on('blur', function () {
  let val = parseInt($(this).val()) || initialQty;

  if (val < initialQty) val = initialQty;
  if (val > 999) val = 999;

  $(this).val(val);
  updateSummaryUI();
});



// =============================
// 5. Left Side Item Box +/- Buttons (no disable)
// =============================


$('.qty-control .qty-plus').on('click', function () {
  const $item = $(this).closest('.choco-item');
  const $qty = $item.find('.qty-display');
  let current = parseInt($qty.val()) || 0;

  let totalAll = 0;
  let totalRound = 0;

  $('.choco-item .qty-display').each(function() {
    const $el = $(this).closest('.choco-item');
    const val = parseInt($(this).val()) || 0;
    totalAll += val;
    if ($el.data('round') === true || $el.data('round') === 'true') totalRound += val;
  });

  if ($item.data('round') === true || $item.data('round') === 'true') {
    const maxRound = Math.floor(parseInt($item.data('max-corporate')) / 2) || 0;
    const allowed = Math.min(maxRound - totalRound, maxItems - totalAll);
    if (allowed <= 0) return;
    $qty.val(current + 1);
  } else {
    if (totalAll >= maxItems) return;
    $qty.val(current + 1);
  }
});


$('.qty-control .qty-minus').on('click', function () {
  const $display = $(this).siblings('.qty-display');
  const currentQty = parseInt($display.val()) || 0;
  if (currentQty > 0) $display.val(currentQty - 1);
});




$('.qty-display').on('input blur', function () {
  const $this = $(this);
  let val = parseInt($this.val()) || 0;
  if (val < 0) val = 0;

  const $item = $this.closest('.choco-item');

  let totalAll = 0;
  let totalRound = 0;
  $('.choco-item .qty-display').each(function() {
    const $el = $(this).closest('.choco-item');
    const v = parseInt($(this).val()) || 0;
    totalAll += v;
    if ($el.data('round') === true || $el.data('round') === 'true') totalRound += v;
  });

  if ($item.data('round') === true || $item.data('round') === 'true') {
    const maxRound = Math.floor(parseInt($item.data('max-corporate')) / 2) || 0;
    const allowed = Math.min(maxRound - (totalRound - val), maxItems - totalAll + val);
    val = Math.min(val, allowed > 0 ? allowed : 0);
  } else {
    const allowed = maxItems - totalAll + val;
    val = Math.min(val, allowed > 0 ? allowed : 0);
  }

  $this.val(val);
});



$('#pralineTotalQty').on('input', function () {
  updateSummaryUI();
});

  // =============================
  // 6. Commit Quantity on "Add Control"
  // =============================
  $('.add_control').on('click', function () {
    const $item = $(this).closest('.choco-item');
    const id = $item.data('id');
    const title = $item.data('title');
    const price = parseFloat($item.data('price'));
    const image = $item.find('img').attr('src');
 const qty = parseInt($item.find('.qty-display').val()) || 0;


    if (qty === 0) {
      if (selected[id]) {
        delete selected[id];
        updateSummaryUI();
      }
      return;
    }

    const currentTotal = Object.entries(selected).reduce((sum, [, i]) => sum + i.qty, 0);
    const existingQty = selected[id]?.qty || 0;
    const remainingAllowed = maxItems - currentTotal + existingQty;

    if (qty > remainingAllowed) return;

    selected[id] = { title, qty, price, image };
    updateSummaryUI();
  });

  // =============================
  // 7. Right Summary Panel +/- Buttons
  // =============================
  $('#selectedPralines').on('click', '.qty-plus', function () {
    const id = $(this).closest('.selected-item').data('id');
    if (!selected[id]) return;

    const currentTotal = Object.values(selected).reduce((sum, i) => sum + i.qty, 0);
    if (currentTotal >= maxItems) return;

    selected[id].qty++;
    updateSummaryUI();
  });

  $('#selectedPralines').on('click', '.qty-minus', function () {
    const id = $(this).closest('.selected-item').data('id');
    if (!selected[id]) return;

    if (selected[id].qty > 1) {
      selected[id].qty--;
    } else {
      delete selected[id];
    }
    updateSummaryUI();
  });

  // =============================
  // 8. Add to Cart Button
  // =============================
  $('#addToCartBtn').on('click', function (e) {
    e.preventDefault();
    const selectedDate = $('#selectedDate').val().trim();
    const totalQty = parseInt($qtyInput.val()) || 1;
    

    const $btn = $(this);
    
     
    if (!$btn.is('[data-id="no-max-qty"]')) {
      const maxCorporate = window.chocoBoxMaxItems || 24;
      let totalSelectedQty = Object.values(selected).reduce((sum, item) => sum + item.qty, 0);

      if (totalSelectedQty !== maxCorporate) {
        if ($('#pralineQtyError').length === 0) {
          $('#selectedPralines').after('<div id="pralineQtyError" style="color:red; margin-top:5px;">Nur volle Schachteln mit ' + maxCorporate + ' Pralinen möglich</div>');
  
        }
        return false; 
      } else {
        $('#pralineQtyError').remove(); 
      }
     
    }




    const mainProductId = $('input[name="id"]').val();
    if (!mainProductId) return;

    const pralineSummary = Object.values(selected)
      .map(i => `${i.title} x ${i.qty}`)
      .join(', ');

      const properties = {
        "Erlesene Pralinen": pralineSummary,
        "Min Qty": initialQty
      };

      if (selectedDate) {
        properties["Ausgewähltes Datum"] = selectedDate;
      }


    const items = [{
      id: parseInt(mainProductId),
      quantity: totalQty,
      properties
    }];

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items }),
      contentType: "application/json",
      dataType: "json",
      success: function () {
         const finalQty = parseInt($('#pralineTotalQty').val()) || 1;
         const separator = redirectLink.includes('?') ? '&' : '?';
          window.location.href = redirectLink + separator + 'qty=' + finalQty;
      },
      error: function () {
        console.log("An error occurred while adding to cart.");
      }
    });
  });

  // =============================
  // 9. Initialize UI
  // =============================
  updateSummaryUI();
});
